import React from "react";
import { MultiSelect } from "primereact/multiselect";
import { useTranslation } from "react-i18next";

const NON_EDITABLE_FIELDS = [
  "multidistrictId"
];
const MultiSelectDropdown = ({
  input,
  label,
  asterisk,
  disabled,
  options,
  meta: { touched, error },
  mode, 
  roleName, 
}) => {
  const { t } = useTranslation("master");
  const isDisabled = () => {
    if (mode === "Update") {
      return NON_EDITABLE_FIELDS.includes(input.name) && input.value.length > 0;
    }
    if (mode === "Add" && input.name === "areaId") {
      return ["UPHC MO", "PHC MO"].includes(roleName);
    }
    return false;
  };
  const handleChange = (e) => {
    input.onChange(e.target.value);
  };
  const handleBlur = () => {
    input.onBlur();
  };
  const disabledClass = isDisabled()
    ? "bg-gray-200 cursor-not-allowed border-gray-300"
    : "";
  return (
    <>
      <label className="input-label">
        <span className="astoricstyle">{asterisk}</span>
        {t(label)}
      </label>
      <MultiSelect
        {...input}
        options={options}
        disabled={disabled || isDisabled()}
        onChange={handleChange}
        onBlur={handleBlur}
        showSelectAll={false}
        maxSelectedLabels={3}
        filter
        className={`input-style ${touched && error ? "border-red-500" : ""} ${disabledClass}`}
      />
      {touched && error && <span className="text-red-500">{error}</span>}
    </>
  );
};

export default MultiSelectDropdown;
